import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'consts';
import { useGetCurrentBoardId, useGetCurrentOrganisationId } from 'hooks';

import { patchForm } from '../requests';
import { PatchFormRequestType } from '../types';

type QueryParams = {
  id: string | number;
};

export const usePatchForm = ({ id }: QueryParams) => {
  const queryClient = useQueryClient();
  const organisationId = useGetCurrentOrganisationId();
  const boardId = useGetCurrentBoardId();

  return useMutation({
    mutationFn: (bodyParams: PatchFormRequestType['bodyParams']) =>
      patchForm({
        pathParams: { organisationId, boardId: boardId!, formId: id },
        bodyParams,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [API_QUERY_KEYS.form, { formId: Number(id) }],
      });
      queryClient.invalidateQueries({
        queryKey: [API_QUERY_KEYS.boardForms, { organisationId, boardId }],
      });
    },
  });
};
